import { EnumEndpoints, EnumEndpointsName, EnumMethod } from "@/constants/app/type";
import { callbackCreateOrder } from "./callbacks/callbackCreateOrder";
import { EnumAPIKey } from "@/constants/app/api";

export const bookingEnpoints = {
  [EnumEndpointsName.FLIGHT_CREATE_ORDER]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.FLIGHT_CREATE_ORDER,
    api: EnumAPIKey.API_BASE,
    caller: callbackCreateOrder
  },
  [EnumEndpointsName.FLIGHT_UPDATE_ORDER]: {
    method: EnumMethod.PUT,
    endpoint: EnumEndpoints.FLIGHT_UPDATE_ORDER,
    api: EnumAPIKey.API_BASE
  },
  [EnumEndpointsName.BOOKING_CHECKOUT]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.BOOKING_CHECKOUT,
    api: EnumAPIKey.API_BASE
  },
  [EnumEndpointsName.BOOKING_REPAYMENT]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.BOOKING_REPAYMENT,
    api: EnumAPIKey.API_BASE
  },
  [EnumEndpointsName.ORDER_DETAIL]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.ORDER_DETAIL,
    api: EnumAPIKey.API_BASE,
  },
  [EnumEndpointsName.ORDER_DETAIL_PARTNER]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.ORDER_DETAIL_PARTNER,
    api: EnumAPIKey.API_BASE,
  },
  [EnumEndpointsName.PREVIEW_ORDER]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.PREVIEW_ORDER,
    api: EnumAPIKey.API_BASE,
  },
  [EnumEndpointsName.GET_ALL_ORDERS]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.GET_ALL_ORDERS,
    api: EnumAPIKey.API_BASE,
  },
}